import React from "react";

import { Region } from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/workflows_pb";

import {
  UserInspectionsList,
  UserTemplatesList,
} from "../../../context/user-templates-and-inspections-context";
import UserTemplatesAndInspectionsList from "./user-templates-and-inspections-list";

interface UserTemplatesAndInspectionsTabProps {
  getUserInspectionsList: (
    ownerId: string,
    pageSize: number,
    offset: number,
  ) => void;
  getUserTemplatesList: (
    ownerId: string,
    pageSize: number,
    offset: number,
  ) => void;
  userInspectionsList: UserInspectionsList;
  userTemplatesList: UserTemplatesList;
  transferInspections: (toID: string, inspectionIDs: string[]) => void;
  transferTemplates: (toID: string, templateIDs: string[]) => void;
  searchArchivedTemplates: boolean;
  setSearchArchivedTemplates: (includeArchived: boolean) => void;
  searchArchivedInspections: boolean;
  setSearchArchivedInspections: (includeArchived: boolean) => void;
  restoreTemplateVersion: (inspectionId: string, targetUserId: string) => void;
  copyTemplate: (
    templateId: string,
    targetUserId: string,
    targetOrgId: string,
    targetRegion: Region,
  ) => void;
  orgId: string;
}

const UserTemplatesAndInspectionsTab = ({
  getUserInspectionsList,
  getUserTemplatesList,
  userInspectionsList,
  userTemplatesList,
  transferInspections,
  transferTemplates,
  searchArchivedTemplates,
  setSearchArchivedTemplates,
  searchArchivedInspections,
  setSearchArchivedInspections,
  restoreTemplateVersion,
  copyTemplate,
  orgId,
}: UserTemplatesAndInspectionsTabProps) => {
  return (
    <>
      <UserTemplatesAndInspectionsList
        getUserItemsList={(ownerId, pageSize, offset) => {
          getUserTemplatesList(ownerId, pageSize, offset);
        }}
        documentType="template"
        totalItems={userTemplatesList.userTemplatesListResponse.totalItems}
        pageSize={userTemplatesList.pagination.pageSize}
        offset={userTemplatesList.pagination.offset}
        userItemsList={userTemplatesList}
        transferDocuments={transferTemplates}
        searchArchived={searchArchivedTemplates}
        setSearchArchived={setSearchArchivedTemplates}
        restoreTemplateVersion={restoreTemplateVersion}
        copyTemplate={copyTemplate}
        orgId={orgId}
      />
      <UserTemplatesAndInspectionsList
        getUserItemsList={(ownerId, pageSize, offset) => {
          getUserInspectionsList(ownerId, pageSize, offset);
        }}
        documentType="inspection"
        totalItems={userInspectionsList.userInspectionsListResponse.totalItems}
        pageSize={userInspectionsList.pagination.pageSize}
        offset={userInspectionsList.pagination.offset}
        userItemsList={userInspectionsList}
        transferDocuments={transferInspections}
        searchArchived={searchArchivedInspections}
        setSearchArchived={setSearchArchivedInspections}
        restoreTemplateVersion={restoreTemplateVersion}
        copyTemplate={copyTemplate}
        orgId={orgId}
      />
    </>
  );
};
export default UserTemplatesAndInspectionsTab;
